var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"enhanced-map-wrapper",attrs:{"data-cy":"enhanced-map-wrapper"}},[_c('div',{ref:"mappingContainer",staticClass:"h-100",class:_vm.mapType,attrs:{"id":"divMappingContainer","data-cy":"mapping-container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }